import React from "react";
import { toast } from "sonner";
import { Copy, RefreshCw, Loader2, Linkedin } from "lucide-react";

function CopyBlock({ label, text, testId }) {
  const copy = () => {
    navigator.clipboard.writeText(text).then(() => toast.success(`${label} copied!`)).catch(() => toast.error("Could not copy — select text manually"));
  };
  return (
    <div className="glass-panel rounded-2xl p-5" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">{label}</p>
        <button onClick={copy} data-testid={`${testId}-copy-btn`} className="flex items-center gap-1.5 text-xs font-semibold text-indigo-400 hover:text-indigo-300">
          <Copy className="w-3.5 h-3.5" /> Copy
        </button>
      </div>
      <p className="text-sm text-slate-300 whitespace-pre-line leading-relaxed">{text}</p>
    </div>
  );
}

export default function LinkedInTab({ content, onRegenerate, regenerating }) {
  if (!content) return null;
  return (
    <div className="space-y-6" data-testid="linkedin-tab">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs text-slate-400">
          <Linkedin className="w-3.5 h-3.5 text-indigo-400" /> Ready-to-post AI-generated LinkedIn content
        </div>
        <button onClick={onRegenerate} disabled={regenerating} data-testid="linkedin-regenerate-btn" className="flex items-center gap-1.5 text-xs font-semibold text-slate-300 hover:text-white bg-white/5 hover:bg-white/10 px-3 py-1.5 rounded-lg disabled:opacity-60">
          {regenerating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} Regenerate
        </button>
      </div>

      <CopyBlock label="Professional Headline" text={content.headline} testId="linkedin-headline" />
      <CopyBlock label="About Section" text={content.about} testId="linkedin-about" />
      <div className="glass-panel rounded-2xl p-5" data-testid="linkedin-skills">
        <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-3">Featured Skills</p>
        <div className="flex flex-wrap gap-2">
          {content.featured_skills.map((s, i) => <span key={i} className="text-xs px-3 py-1.5 rounded-full border border-indigo-400/20 bg-indigo-400/5 text-indigo-300">{s}</span>)}
        </div>
      </div>
      {content.project_descriptions.map((p, i) => (
        <CopyBlock key={i} label={`Project: ${p.title}`} text={p.description} testId={`linkedin-project-${i}`} />
      ))}
      <CopyBlock label="Certification Summary Post" text={content.certification_summary} testId="linkedin-cert-summary" />
    </div>
  );
}
